module.exports = __webpack_public_path__ + "public/img/arrow-rb.22f97e0c.svg";